import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { take } from 'rxjs/operators';
import { ModalService } from '@app/@core/modal/modal.service';
import { SpinnerService } from '../spinner/spinner.service';
import { CustomDialogComponent } from '../modal/customDialog/customDialog.component';
import { UserService } from '@app/services/user.service';
import { WellBeingService } from '@app/wellBeing/wellBeing.service';

@Component({
  selector: 'app-wellbeing-table',
  templateUrl: './wellBeing.component.html',
  styleUrls: ['./wellBeing.component.scss'],
})
export class WellBeingTableComponent {
  @Input() isLoading = false;
  @Input() message: string;
  @Input() dataTable: string;
  @Input() dataColumn: string;
  first = 0;
  rows = 5;
  values = '';

  constructor(
    private modalService: ModalService,
    private messageService: MessageService,
    private spinnerService: SpinnerService,
    public userService: UserService,
    public wellBeingService: WellBeingService
  ) {}

  getIndex(arr: any, activity: any) {
    let index = arr.map((item: any) => item.id).indexOf(activity['id']);
    return index;
  }

  next() {
    this.first = this.first + this.rows;
  }

  prev() {
    this.first = this.first - this.rows;
  }

  reset() {
    this.first = 0;
  }

  isLastPage(): boolean {
    return this.dataTable ? this.first === this.dataTable.length - this.rows : true;
  }

  isFirstPage(): boolean {
    return this.dataTable ? this.first === 0 : true;
  }

  deleteActivity(activity: any): void {
    this.modalService
      .confirm('Are you sure that you want to remove ' + activity['name'])
      .pipe(take(1))
      .subscribe((confirmed: any) => {
        if (confirmed) {
          this.spinnerService.show();
          this.removeWellBeingActivity(activity);
        }
      });
  }

  openEditForm(formData: any): void {
    this.modalService
      .custom(CustomDialogComponent, {
        title: 'Edit Well-Being',
        modalType: 'add-edit-wellbeing',
        formType: 'Edit',
        formData: formData,
      })
      .pipe(take(1)) // take() manages unsubscription for us
      .subscribe((result: any) => {
        if (result) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Well-Being activity is updated succesfully.',
          });
        }
      });
  }

  removeWellBeingActivity(activity: any): void {
    this.wellBeingService.deleteWellBeingActivity(activity.uuid).then(() => {
      this.spinnerService.hide();
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: activity['name'] + ' is deleted successfully',
      });
    });
  }
}
